import React from "react";
import noData from "../../../../assets/Illustrations/emptyFreeGuides.svg";

const FGNoData = ({ text }) => {
  return (
    <div className="flex flex-col justify-center items-center pb-4 px-2">
      <img src={noData} alt="no-free-guides" width={350} />
      <div className="text-[#475467] mt-3 text-[1rem] font-medium text-center mx-auto max-w-[380px]">
        {text}
      </div>
    </div>
  );
};

export default FGNoData;
